import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, useNavigate, Link } from "react-router-dom";
import {
  connectToWallet,
  getAllAccountDetails,
  getAccountBalance,
} from "../Services/Index";

import { store } from "../Redux/store";

const Header = (props) => {
  const [Disable, setDisable] = useState(true);
  const [staticAddr, setStatic] = useState("");

  useEffect(async () => {
    await AccountStateUpdate();
    let data = JSON.parse(localStorage.getItem("InfinityStatus"));
    console.log(data);
    if (data !== null) {
      handleClick();
    }
  }, []);

  function AccountStateUpdate() {
    window.ethereum.on("accountsChanged", async (accounts) => {
      props.setConnect(false);
      store.getState().ConnectivityReducer.metamaskAddress = accounts[0];
      store.getState().ConnectivityReducer.metamaskBalance = await (
        await getAccountBalance(accounts[0])
      ).accountBalance;
      console.log(store.getState().ConnectivityReducer);
      props.setConnect(true);
    });
  }
  const navigate = useNavigate();

  function handleClick() {
    getAllAccountDetails().then((res) => {
      if (res.result !== "") {
        props.setConnect(true);
        localStorage.setItem(
          "InfinityStatus",
          JSON.stringify({ status: true })
        );
        setDisable(false);
      }
    });
  }

  function handleLogout() {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };
    props.setConnect(false);
    localStorage.removeItem("InfinityStatus");
    window.location.reload();
  }

  function _sliceAddress(address) {
    return (
      address.slice(0, 6) +
      "..." +
      address.slice(address.length - 4, address.length)
    );
  }
  return (
    <div style={{ zIndex: "100" }}>
      <nav
        class="navbar navbar-expand-lg "
        style={{ zIndex: "100", background: "#000" }}
      >
        <img
          src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
          class="img-fluid logoheader"
          alt="..."
          width="5%"
          height="5%"
          onClick={() => navigate("/", { replace: true })}
          style={{ cursor: "pointer" }}
        />
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div
          class="collapse navbar-collapse"
          id="navbarSupportedContent"
          style={{ zIndex: "100" }}
        >
          <ul class="navbar-nav mr-auto">
            <Link to="/">
              <li class="nav-item active">
                <a class="nav-link" href="#">
                  Launchpad<span class="sr-only">(current)</span>
                </a>
              </li>
            </Link>
            {/* ---these link is temporary hidden --- */}
            <Link to="/stake">
              <li class="nav-item active">
                <a class="nav-link" href="/stake">
                  Stake<span class="sr-only">(current)</span>
                </a>
              </li>
            </Link>
          </ul>
          <form class="form-inline ml-1 my-lg-0">
            <button
              class="btn btn-outline-success mr-sm-2 btn2 btn-sm networimg"
              style={{ borderRadius: "8px", fontSize: "15px", display: "flex" }}
              type="button"
            >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAGFBMVEUAAAD/xwD/xwD/xwD/zwD/yAD/xgD/xwAOl1etAAAAB3RSTlMAgN8gEM+gZtFyLwAAAHBJREFUCNddj7EJQCEMRCNmADsHsLCVTJDGDQRbV1BQ1//6gwhedTyS3AW2lIEjW49Tc5oD56wHNr+wQEeCMbeg/diWo0OmgmvSYYhJAxmwLWDurH0VO2BZGSiaycgaUEJY+o91vhFvsNS5JZ/q96EPRwgaUSdfEDoAAAAASUVORK5CYII="
                className="mx-2"
                style={{ fontSize: "15px" }}
              />
              {props.Connect
                ? store.getState().ConnectivityReducer.metamaskNetwork
                : "No Network "}
            </button>

            {/* <button
              class="btn btn-outline-success  btn1 btn-sm"
              style={{ borderRadius: "8px" }}
              type="button"
            >
              0 Token
            </button> */}
            <button
              class="btn btn-outline-success  btn1 btn-sm ml-1"
              style={{ borderRadius: "8px", fontFamily: "Outfit, sans-serif'" }}
              type="button"
            >
              {props.Connect
                ? parseFloat(
                    store.getState().ConnectivityReducer.metamaskBalance
                  ).toFixed(4)
                : "0 "}
              {/* BUSD */}
            </button>
            <button
              class="btn btn-outline-success my-2 my-sm-0 btn3 btn-sm"
              style={{ borderRadius: "8px", fontFamily: "Outfit, sans-serif'" }}
              type="button"
              onClick={handleClick}
            >
              {props.Connect
                ? _sliceAddress(
                    store.getState().ConnectivityReducer.metamaskAddress ||
                      staticAddr
                  )
                : "No Conneted"}
            </button>
            <button
              class=" btn-sm ml-1"
              style={{
                borderRadius: "8px",
                fontFamily: "Outfit, sans-serif'",
                background: "#dd6f20",
                color: "#fff",
                display: props.Connect === true ? "block" : "none",
              }}
              type="button"
              onClick={handleLogout}
            >
              Logout
            </button>
          </form>
        </div>
      </nav>
      <div data-v-fa77f052="" class="menu">
        <div data-v-fa77f052="" class="menu__subline subline">
          <div data-v-fa77f052="" class="subline__left subline__sheel">
            <div data-v-fa77f052="" class="subline__seed"></div>
          </div>
          <div data-v-fa77f052="" class="subline__line"></div>{" "}
          <div data-v-fa77f052="" class="subline__right"></div>
        </div>
      </div>
    </div>
  );
};

export default Header;
